var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82373 17.3492C6.82373 16.8505 7.24511 16.4463 7.76491 16.4463H16.2355C16.7553 16.4463 17.1767 16.8505 17.1767 17.3492C17.1767 17.8478 16.7553 18.2521 16.2355 18.2521H7.76491C7.24511 18.2521 6.82373 17.8478 6.82373 17.3492Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82373 13.7374C6.82373 13.2387 7.24511 12.8345 7.76491 12.8345H16.2355C16.7553 12.8345 17.1767 13.2387 17.1767 13.7374C17.1767 14.236 16.7553 14.6403 16.2355 14.6403H7.76491C7.24511 14.6403 6.82373 14.236 6.82373 13.7374Z",
    fill: "#767676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82373 10.126C6.82373 9.62738 7.24511 9.22314 7.76491 9.22314H16.2355C16.7553 9.22314 17.1767 9.62738 17.1767 10.126C17.1767 10.6247 16.7553 11.0289 16.2355 11.0289H7.76491C7.24511 11.0289 6.82373 10.6247 6.82373 10.126Z",
    fill: "#767676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82373 6.51422C6.82373 6.01557 7.24511 5.61133 7.76491 5.61133H16.2355C16.7553 5.61133 17.1767 6.01557 17.1767 6.51422C17.1767 7.01287 16.7553 7.41711 16.2355 7.41711H7.76491C7.24511 7.41711 6.82373 7.01287 6.82373 6.51422Z",
    fill: "#767676"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05859 4.70874C3.05859 2.71412 4.74411 1.09717 6.8233 1.09717H17.1762C19.2554 1.09717 20.9409 2.71412 20.9409 4.70874V19.155C20.9409 21.1496 19.2554 22.7666 17.1762 22.7666H6.8233C4.74411 22.7666 3.05859 21.1496 3.05859 19.155V4.70874ZM6.8233 2.90295C5.78371 2.90295 4.94095 3.71143 4.94095 4.70874V19.155C4.94095 20.1523 5.78371 20.9608 6.8233 20.9608H17.1762C18.2158 20.9608 19.0586 20.1523 19.0586 19.155V4.70874C19.0586 3.71143 18.2158 2.90295 17.1762 2.90295H6.8233Z",
    fill: "#767676"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSns);
export default __webpack_public_path__ + "static/media/icon-sns.eedc0c141f98eb8552832ff7404a729b.svg";
export { ForwardRef as ReactComponent };